import {
  Timezone as Data,
  TimezoneCollection as Collection,
} from '@/typings/api/Timezone'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class CoreTimezonesApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'core/timezones';
}
